import { Component, OnInit, OnDestroy, Input, ContentChild, TemplateRef, ElementRef } from '@angular/core';
import { IAuthorizationService } from '@pershing/pershing-core';

@Component({
    selector: 'pershing-component',
    styles: [`
        .full-height {
            display: flex;
            height: 100%
        }
        .dc .mat-expansion-panel-header {
            background: inherit !important;
            padding: 0 24px !important;
        }
        .dc .mat-expansion-panel {
            border: none;
        }
        .dc-Actions {
            padding-top: 3px;
            padding-bottom: 0px;
            transition: all 0.25s ease;
        }
        .dc-Actions.expanded {
            padding-top: 0px;
            padding-bottom: 10px;
            transition: all 0.25s ease;
        }
    `],
    templateUrl: 'pershing-wrapper.component.html'
})
export class PershingComponent implements OnDestroy, OnInit {

    @Input() componentMeta: any;
    @ContentChild(TemplateRef, { static: false }) templateRef: TemplateRef<any>;
    isEntitled: boolean;
    isExpanded: boolean = true;
    actions: any = null;
    contentStyle: any = null;
    componentContent: any = undefined;
    constructor(private auth: IAuthorizationService) { }
    convertCamelToKebab(key) {
        return key
            .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
            .replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2')
            .toLowerCase();
    }
    createElementInputs(inputs) {
        let inputString = '';
        for (const key in inputs) {
            if (inputs[key]) {
                console.log('typeof ', key, typeof inputs[key] === 'object');
                const value = (typeof inputs[key] === 'object') ? JSON.stringify(inputs[key]) : inputs[key];
                inputString += ' ' + this.convertCamelToKebab(key) + '=\'' + value + '\'';
            }
        }
        return inputString;
    }
    ngOnInit() {
        if (this.componentMeta && typeof this.componentMeta === 'string') {
            this.componentMeta = JSON.parse(this.componentMeta);
        }
        if (this.componentMeta && this.componentMeta.isAngularElements) {
            this.componentContent = '<' + this.componentMeta.selector +
                this.createElementInputs(this.componentMeta.input) + '></' + this.componentMeta.selector + '>';
        }
        this.setContentStyle(this.componentMeta);
        this.entitlementCheck(this.componentMeta.entitlement);
        this.actions = (this.componentMeta.actions) ? Object.keys(this.componentMeta.actions) : null;
    }

    setContentStyle(componentData: any) {
        if (componentData.height !== 'FULL') {
            this.contentStyle = {
                'height': componentData.height,
                'overflow-y': 'auto'
            };
        }
    }

    entitlementCheck(entitlement: string) {
        if (entitlement) {
            this.isEntitled = this.auth.isEntitled(entitlement);
        }
    }

    public ngOnDestroy() {
        console.log('PERHSING-COMPONENT ON DESTROY');
    }

}
